<template>

    <CardShell>

        <!-- Upcoming rentals -->
        <MenuItem
            class="ph3 h3"
            :image="require(`@/assets/img/icon_calendar.svg`)"
            title="Upcoming Rentals"
            :count="upcomingRentalCount"
            route="/upcoming-rentals"
            :childRoutes="['/upcoming-rental']"
        />

        <!-- Rental History -->
        <MenuItem
            class="ph3 h3"
            :image="require(`@/assets/img/icon_time.svg`)"
            title="Rental History"
            route="/rentals-history"
            :childRoutes="['/rental-history']"
        />
        
    </CardShell>

</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import MenuItem from '@/components/global/MenuItem.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        CardShell,
        MenuItem
    },
    computed: {
        ...mapGetters('rentals', ['upcomingRentalCount'])
    }
};
</script>
